import { FloraTypography } from '@grupoboticario/flora-react';

import Styles from '../components/Login.components.styles';

export const CallCenter = () => {
  return (
    <Styles.CallCenterButtom
      autotagging-flora="on"
      data-flora-text="central-de-atendimento"
      data-flora="button"
      variant="unstyled"
      size="small"
      href="/perguntas-frequentes"
      as="a"
    >
      <FloraTypography
        fontSize="exceptionsAuxiliar"
        fontWeight="regular"
        color="$actionNavigationStandardStatic"
      >
        Central de Atendimento.
      </FloraTypography>
    </Styles.CallCenterButtom>
  );
};
export default CallCenter;
